
export class ProgramAssetsNav {
  public static item = {
    title: 'program.tab.assets',
    url: 'assets',
    icon: '<img src="./assets/icons/line-icons/nav/grey/application.svg" width="23px" height="23px">',
    testId: 'prog-nav-assets'
  };
}
